import en from './en';
import fr from './fr';

export default class Translator {
    constructor(defaultLang = "en") {
        this.locales = {};
        this.listeners = [];

        this.locales["en"] = en;
        this.locales["fr"] = fr;

        this.lang = defaultLang;

        if (window.localStorage["lang"] !== null) {
            this.changeLang(window.localStorage["lang"]);
        }
    }

    onLangChange(callback) {
        this.listeners.push(callback);
    }

    offLangChange(callback) {
        this.listeners = this.listeners.filter(fn => fn !== callback);
    }

    notifyLangChange() {
        this.listeners.forEach(fn => fn(this.lang));
    }

    switchLang() {
        this.lang = this.lang === "en" ? "fr" : "en";
        this.changeLang(this.lang);
    }

    changeLang(lang) {
        this.lang = ["fr", "en"].includes(lang) ? lang : "en";
        window.localStorage["lang"] = this.lang;
        this.notifyLangChange();
    }

    get(key) {
        return this.locales[this.lang][key];
    }

    getCurrentLang() {
        return this.lang;
    }

    read(key) {
        if (window.localStorage["lang"] === null || !["fr", "en"].includes(window.localStorage["lang"])) {
            this.changeLang(this.lang);
        }

        const arr = key.split(".");
        let obj = this.locales[this.lang];

        for (const part of arr) {
            if (obj == null) return undefined;
            obj = obj[part];
        }

        return obj;
    }
}